import { render } from "./PropertiesTab.vue?vue&type=template&id=0ee24b30&ts=true"
import script from "./PropertiesTab.vue?vue&type=script&lang=ts"
export * from "./PropertiesTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__